<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="commonTableStyles contractApproval">
            <van-nav-bar
                title=""
                left-text="应用"
                left-arrow
                @click-left="onClickLeft"
            >
                <template #title>
                    <div
                        :class="{'active': listType == 'db'}"
                        @click="listSwitch('db')"
                    >
                        待审批
                    </div>
                    <div
                        :class="{'active': listType == 'yb'}"
                        @click="listSwitch('yb')"
                    >
                        已审批
                    </div>
                </template>
            </van-nav-bar>
            <section>
                <van-search v-model="value" placeholder="请输入搜索信息" @change="search"></van-search>
                <ul class="contractClassMenu">
                    <li
                        v-for="(item,index) in typeCate"
                        :key="item.code"
                        :class="{active:activeTypeCate == index}"
                        @click="typeCateChange(index)"
                    >
                        <!-- <strong :class="['iconfont',item.icon]"></strong>
                        <span>{{ item.name }}：</span>
                        <strong>{{ item.total || 0 }}</strong> -->
                        <strong :class="['iconfont',item.icon]"></strong>
                        <span>{{ item.name }}</span>
                        <strong v-if="item.total&&listType=='db'">：{{ item.total }}</strong>
                    </li>
                </ul>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list
                        v-model="isUpLoading"
                        :finished="finished"
                        finished-text="没有更多了!"
                        @load="onLoad"
                        :immediate-check="false"
                    >
                        <ul class="list">
                            <template v-for="(item, index) in listData">
                                <!-- 销售-->
                                <li
                                    v-if="activeTypeCate==0"
                                    class="approval"
                                    :key="index"
                                    @click="openApprovalProcess(item)"
                                >
                                    <div class="engineeringInfo">
                                        <h4 class="engineeringInfo_header">
                                            <span class="state">
                                                <i v-if="item.BusinessShortName">{{ item.BusinessShortName }}</i>
                                                <i v-else>{{ typeCate[activeTypeCate].name }}</i>
                                            </span>
                                            <span class="headerName">审批事项：{{ item.BusinessInstanceName }}</span>
                                        </h4>
                                        <div class="engineeringInfo_content">
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_1.png" alt="">
                                                <span>合同编号：{{ item.contract_number }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_8.png" alt="">
                                                <span>客户名称：{{ item.client_name }}</span>
                                            </p>
                                            <p v-if="item.tenant_name">
                                                <img src="@/assets/images/icons/icon_gy_8.png" alt="">
                                                <span>公司名称：{{ item.tenant_name }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                                                <span>工程名称：{{ item.engineering_name }}</span>
                                            </p>
                                            <template v-if="listType == 'db'">
                                                <p>
                                                    <img src="@/assets/images/icons/icon_3.png" alt="">
                                                    <span>提交人：{{ item.preApproverName }}</span>
                                                </p>
                                                <p>
                                                    <img src="@/assets/images/icons/icon_gy_7.png" alt="">
                                                    <span>提交时间：{{ item.SubmitTime }}</span>
                                                </p>
                                            </template>
                                            <template v-else-if="listType == 'yb'">
                                                <p>
                                                    <img src="@/assets/images/icons/icon_40.png" alt="">
                                                    <span v-if="item.Status < 3">办理状态：审批中</span>
                                                    <span v-if="item.Status == 3">已办结</span>
                                                </p>
                                                <template v-if="item.Status == 3">
                                                    <p>
                                                        <img src="@/assets/images/icons/icon_3.png" alt="">
                                                        <span>办结人：{{ item.ApproverOverName }}</span>
                                                    </p>
                                                    <p>
                                                        <img src="@/assets/images/icons/icon_gy_7.png" alt="">
                                                        <span>办结时间：{{ item.EndTime }}</span>
                                                    </p>
                                                </template>
                                                <template v-else>
                                                    <p>
                                                        <img src="@/assets/images/icons/icon_gy_10.png" alt="">
                                                        <span>办理进度：{{ item.BusinessPhaseName }}</span>
                                                    </p>
                                                    <p>
                                                        <img src="@/assets/images/icons/icon_3.png" alt="">
                                                        <span>办理人：{{ item.ApproverCurName }}</span>
                                                    </p>
                                                </template>
                                            </template>
                                        </div>
                                    </div>
                                </li>
                                <!-- 采购-->
                                <li
                                    v-else-if="activeTypeCate==1"
                                    class="approval"
                                    :key="index"
                                    @click="openApprovalProcess(item)"
                                >
                                    <div class="engineeringInfo">
                                        <h4 class="engineeringInfo_header">
                                            <span class="state">
                                                <i v-if="item.BusinessShortName">{{ item.BusinessShortName }}</i>
                                                <i v-else>{{ typeCate[activeTypeCate].name }}</i>
                                            </span>
                                            <span class="headerName">审批事项：{{ item.BusinessInstanceName }}</span>
                                        </h4>
                                        <div class="engineeringInfo_content">
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_1.png" alt="">
                                                <span>合同编号：{{ item.contract_no }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                                                <span>合同名称：{{ item.contract_name }}</span>
                                            </p>
                                            <p v-if="item.tenant_name">
                                                <img src="@/assets/images/icons/icon_gy_8.png" alt="">
                                                <span>公司名称：{{ item.tenant_name }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_8.png" alt="">
                                                <span>供应商/运输商：{{ item.supplier_name }}</span>
                                            </p>
                                            <template v-if="listType == 'db'">
                                                <p>
                                                    <img src="@/assets/images/icons/icon_3.png" alt="">
                                                    <span>提交人：{{ item.preApproverName }}</span>
                                                </p>
                                                <p>
                                                    <img src="@/assets/images/icons/icon_gy_7.png" alt="">
                                                    <span>提交时间：{{ item.SubmitTime }}</span>
                                                </p>
                                            </template>
                                            <template v-else-if="listType == 'yb'">
                                                <p>
                                                    <img src="@/assets/images/icons/icon_40.png" alt="">
                                                    <span v-if="item.Status < 3">办理状态：审批中</span>
                                                    <span v-if="item.Status == 3">已办结</span>
                                                </p>
                                                <template v-if="item.Status == 3">
                                                    <p>
                                                        <img src="@/assets/images/icons/icon_3.png" alt="">
                                                        <span>办结人：{{ item.ApproverOverName }}</span>
                                                    </p>
                                                    <p>
                                                        <img src="@/assets/images/icons/icon_gy_7.png" alt="">
                                                        <span>办结时间：{{ item.EndTime }}</span>
                                                    </p>
                                                </template>
                                                <template v-else>
                                                    <p>
                                                        <img src="@/assets/images/icons/icon_gy_10.png" alt="">
                                                        <span>办理进度：{{ item.BusinessPhaseName }}</span>
                                                    </p>
                                                    <p>
                                                        <img src="@/assets/images/icons/icon_3.png" alt="">
                                                        <span>办理人：{{ item.ApproverCurName }}</span>
                                                    </p>
                                                </template>
                                            </template>
                                        </div>
                                    </div>
                                </li>
                                <!-- 物流-->
                                <li
                                    v-else-if="activeTypeCate==2"
                                    class="approval"
                                    :key="index"
                                    @click="openApprovalProcess(item)"
                                >
                                    <div class="engineeringInfo">
                                        <h4 class="engineeringInfo_header">
                                            <span class="state">
                                                <i v-if="item.BusinessShortName">{{ item.BusinessShortName }}</i>
                                                <i v-else>{{ typeCate[activeTypeCate].name }}</i>
                                            </span>
                                            <span class="headerName">审批事项：{{ item.BusinessInstanceName }}</span>
                                        </h4>
                                        <div class="engineeringInfo_content">
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_1.png" alt="">
                                                <span>合同编号：{{ item.contract_no }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                                                <span>合同名称：{{ item.contract_name }}</span>
                                            </p>
                                            <p v-if="item.tenant_name">
                                                <img src="@/assets/images/icons/icon_gy_8.png" alt="">
                                                <span>公司名称：{{ item.tenant_name }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_8.png" alt="">
                                                <span>运输公司：{{ item.company_name }}</span>
                                            </p>
                                            <template v-if="listType == 'db'">
                                                <p>
                                                    <img src="@/assets/images/icons/icon_3.png" alt="">
                                                    <span>提交人：{{ item.preApproverName }}</span>
                                                </p>
                                                <p>
                                                    <img src="@/assets/images/icons/icon_gy_7.png" alt="">
                                                    <span>提交时间：{{ item.SubmitTime }}</span>
                                                </p>
                                            </template>
                                            <template v-else-if="listType == 'yb'">
                                                <p>
                                                    <img src="@/assets/images/icons/icon_40.png" alt="">
                                                    <span v-if="item.Status < 3">办理状态：审批中</span>
                                                    <span v-if="item.Status == 3">已办结</span>
                                                </p>
                                                <template v-if="item.Status == 3">
                                                    <p>
                                                        <img src="@/assets/images/icons/icon_3.png" alt="">
                                                        <span>办结人：{{ item.ApproverOverName }}</span>
                                                    </p>
                                                    <p>
                                                        <img src="@/assets/images/icons/icon_gy_7.png" alt="">
                                                        <span>办结时间：{{ item.EndTime }}</span>
                                                    </p>
                                                </template>
                                                <template v-else>
                                                    <p>
                                                        <img src="@/assets/images/icons/icon_gy_10.png" alt="">
                                                        <span>办理进度：{{ item.BusinessPhaseName }}</span>
                                                    </p>
                                                    <p>
                                                        <img src="@/assets/images/icons/icon_3.png" alt="">
                                                        <span>办理人：{{ item.ApproverCurName }}</span>
                                                    </p>
                                                </template>
                                            </template>
                                        </div>
                                    </div>
                                </li>
                            </template>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
        </div>
    </v-touch>
</template>
<script>
export default {
    // 合同审批
    name: 'contract-approval',
    components: {},
    props: {},
    beforeRouteLeave(to, from, next) {
        if (to.path !== '/approvalProcess') {
            this.$store.commit('noKeepAlive', 'contract-approval');
        }
        next();
    },
    data() {
        return {
            // showFilter: true,
            // 查询类型
            typeCate: [
                { code: 1, name: '销售', total: 0, icon: 'iconxiaoshoujia', dbCode: 'xs-htsp-dsp', ybCode: 'xs-htsp-ysp' },
                { code: 2, name: '采购', total: 0, icon: 'iconcaigouliebiao', dbCode: 'cg_htsp_dsp', ybCode: 'cg_htsp_ysp' },
                { code: 3, name: '物流', total: 0, icon: 'iconkache1', dbCode: 'wl_htsp_dsp', ybCode: 'wl_htsp_ysp' },
            ],
            // 当前选中的查询类型
            activeTypeCate: 0,
            value: '',
            // 下拉login状态
            isLoading: false,
            // 上拉login状态
            isUpLoading: false,
            // 上拉索引
            count: 0,
            // 列表总条数
            total: 0,
            // 是否已加载完所有数据
            finished: false,
            // 当前打开列表类型，db待办，yb已办
            listType: 'db',
            // 列表数据
            listData: [],
        };
    },
    filters: {
        itemName: function (data) {
            const newData = data.substring(data.length - 2);
            return newData;
        },
    },
    computed: {},
    watch: {},
    activated() {
        if (this.$route.params.isRefresh) {
            this.finished = false;
            this.listData = [];
            this.count = 0;
            this.gitListData();
        }
    },
    created() {
        this.init();
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 首次加载
        async init() {
            this.typeCate.forEach(item => {
                item.cacheKey = Math.floor(Math.random() * 1000000000000 + 1);
            });
            this.$toast.loading();
            await this.getTotal();
            this.gitListData();
            this.$toast.clear();
        },
        // 返回上级页面
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/home' });
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/home' });
        },
        // 搜索
        search() {
            this.count = 0;
            this.listData = [];
            this.finished = false;
            this.gitListData();
        },
        // 下拉刷新
        onRefresh() {
            this.count = 0;
            this.listData = [];
            this.gitListData();
        },
        // 上拉加载更多
        onLoad() {
            this.count++;
            this.gitListData();
        },
        // 待办已办切换
        listSwitch(obj) {
            this.count = 0;
            this.listData = [];
            this.listType = obj;
            this.finished = false;
            this.gitListData();
        },

        // 切换过滤查询类型
        typeCateChange(index) {
            this.activeTypeCate = index;
            this.search();
        },

        // 打开合同审批页
        openApprovalProcess(data) {
            data.BusinessInstanceId = data.business_instance_id;
            this.$router.isBack = 2;
            let isReadOnly = '';
            if (this.listType === 'db') {
                isReadOnly = false;
            } else {
                isReadOnly = true;
            }
            this.$router.push({
                name: 'approvalProcess',
                params: {
                    data: data,
                    isReadOnly: isReadOnly,
                },
            });
        },
        // 获取列表数据
        gitListData() {
            let queryCode = '';
            if (this.listType === 'db') {
                queryCode = this.typeCate[this.activeTypeCate].dbCode;
            } else {
                queryCode = this.typeCate[this.activeTypeCate].ybCode;
            }
            const params = {
                cacheKey: this.typeCate[this.activeTypeCate].cacheKey,
                code: queryCode,
                limit: 6,
                page: this.count,
                searchKey: this.value,
            };
            this.$axios.post('/interfaceApi/basicplatform/tabledata', params)
                .then(res => {
                    this.total = res.total;
                    this.listData.push(...res.rows || []);
                    this.finished = this.listData.length >= this.total;
                    this.isLoading = false;
                    this.isUpLoading = false;
                }) .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // 获取统计
        async getTotal() {
            let cateIndex = null;
            for (const index in this.typeCate) {
                const typeCate = this.typeCate[index];
                const params = {
                    cacheKey: Math.floor(Math.random() * 1000000000000 + 1),
                    code: typeCate.dbCode,
                    limit: 0,
                    page: 0,
                };
                const res = await this.$axios.post('/interfaceApi/basicplatform/tabledata', params);
                typeCate.total = res.total;
                if (!cateIndex && typeCate.total > 0) {
                    cateIndex = index;
                }
            }
            this.activeTypeCate = cateIndex || 0;
        },
        // 获取列表数据
        // gitListData1() {
        //     let getUrl = '';
        //     const user_id = this.$takeTokenParameters('Uid');
        //     if (this.listType === 'db') {
        //         getUrl = '/interfaceApi/basicplatform/simpleflow/processes/transations/' + user_id + '?pageIndex=' + this.count + '&pageSize=5';
        //     } else {
        //       getUrl = '/interfaceApi/basicplatform/simpleflow/processes/transations_over/' + user_id + '?pageIndex=' + this.count + '&pageSize=5';
        //     }
        //     this.$axios
        //         .get(getUrl)
        //         .then(res => {
        //             if (res && res.List.length > 0) {
        //                 this.total = res.PageCount;
        //                 if (this.listData.length < 1 ) {
        //                     this.listData = res.List;
        //                     this.finished = false;
        //                 } else {
        //                     res.List.forEach(item => {
        //                         this.listData.push(item);
        //                     });
        //                 }
        //                 if (this.listData.length === this.total) {
        //                     this.finished = true;
        //                 }
        //             } else {
        //                 this.finished = true;
        //             }
        //             this.isLoading = false;
        //             this.isUpLoading = false;
        //             this.$forceUpdate();
        //         })
        //         .catch(error => {
        //             this.$dialog({ message: error.ErrorCode.Message });
        //         });
        // },
    },
};
</script>
<style lang="stylus">
.contractApproval
    height 100%
    position relative
    .van-nav-bar
        .van-nav-bar__title
            div
                display inline-block
                padding 0 15rpx
                font-size 14rpx
                color rgba(240,240,240,0.7)
                transition 0.2s
                &.active
                    font-size 18rpx
                    color #fff
    section
        height calc(100% - 45rpx)
        overflow: hidden;
        .contractClassMenu
            height 40rpx
            display flex
            justify-content space-around
            li
                padding 0 14rpx
                height: 30rpx;
                font-size: 14rpx;
                line-height 28rpx
                color #888888
                background: #F8F8F8;
                border-radius: 15rpx;
                display flex
                align-items center
                justify-content center
                strong
                    font-weight 600
                    &.iconfont
                        font-size 18rpx
                        font-weight 400
                &.active
                    color #0078FB
                    background: rgba(0,120,251,0.06);
                    border: 1px solid rgba(0,120,251,0.3);
        .van-pull-refresh
            height calc(100% - 85rpx)
            overflow: scroll;
            -webkit-overflow-scrolling: touch;
            .list
                background #F0F0F0
                padding 15rpx
                padding-bottom 0
                min-height 100%
                overflow hidden
                li
                    width 100%
                    background #fff
                    margin-bottom 15rpx
                    &.approval
                        h4
                            .state
                                background-color #2979FF
                    &.transfinite
                        h4
                            .state
                                background-color #E60000
                    &.modifyPrice
                        h4
                            .state
                                background-color #FF6600
                    &.purchase
                        h4
                            .state
                                background-color #00A84B
        >div
            height 100%
            .noData
                font-size 40rpx
                line-height 200rpx
                font-weight 600
                color #ccc
                text-align center
</style>
